import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { useModalStore } from '../../store/uiStore';

interface Props {
  id?: string;
  title?: string;
  message: string;
  onConfirm: () => void | Promise<void>;
  confirmText?: string;
  cancelText?: string;
  variant: keyof typeof icons;
}

const icons = {
  warning: <ExclamationTriangleIcon className="text-red-600 size-6" />,
  success: <CheckCircleIcon className="text-green-600 size-6" />,
  danger: <ExclamationCircleIcon className="text-orange-600 size-6" />,
};

const bgColors = {
  warning: 'bg-red-100',
  success: 'bg-green-100',
  danger: 'bg-orange-100',
};

export function openConfirmationModal({
  id = 'confirm-modal',
  title = 'Are you sure?',
  message,
  onConfirm,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  variant,
}: Props) {
  useModalStore.getState().openModal({
    id,
    title,
    size: 'sm',
    content: (
      <div className="mt-2 flex gap-4">
        <div
          className={`flex size-10 p-2 items-center justify-center rounded-full ${bgColors[variant]}`}
        >
          {icons[variant]}
        </div>
        <p className="text-sm text-gray-500">{message}</p>
      </div>
    ),
    buttons: [
      {
        label: confirmText,
        onClick: async () => {
          await onConfirm();
          useModalStore.getState().closeModal();
        },
        type: 'button',
        variant: variant === 'danger' ? 'danger' : 'primary',
        autoFocus: true,
      },
      {
        label: cancelText,
        onClick: () => useModalStore.getState().closeModal(),
        type: 'button',
        variant: 'outline',
        autoFocus: false,
      },
    ],
  });
}
